import React, { useEffect } from "react";
import { ActionItem, SKArtifact, Tier } from "../../../../../models/SKArtifact";
import { ActionItem as ChannelActionItem } from "../../../../../models/SKChannel";
import { ActionItem as ApplicationActionItem } from "../../../../../models/SKApplication";

export interface DialoageContent {
  message: string;
  description: string;
  actionTitle: string;
  destructiv?: boolean;
}

interface ArtifactStateDialogProps {
  action: ActionItem | ChannelActionItem | ApplicationActionItem;
  onClose: () => void;
  onUpdate: () => void;
  dialogeContent: DialoageContent;
}

const ArtifactStateDialog = ({ action, onClose, onUpdate, dialogeContent }: ArtifactStateDialogProps) => {
  // let dialogContent = getDialogeContent(action);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-[290px] h-[401px]">
        <div className="flex flex-col content-center items-center gap-[15px] h-[215px] p-[20px]">
          <div className="flex flex-col justify-center content-center items-center]">
            <h2 className="popup-title">{dialogeContent.message}</h2>
          </div>
          <div>
            <p className="popup-sub-title">{dialogeContent.description}</p>
          </div>
        </div>
        <div className="flex flex-col content-center items-center gap-[20px]">
          <div className="thickseparator"></div>
          {!dialogeContent.destructiv ? (
            <button className="text-black bg-white popup-button-action" onClick={onUpdate}>
              {dialogeContent.actionTitle}
            </button>
          ) : (
            <button className="text-[#FF3B30] bg-white popup-button-action" onClick={onUpdate}>
              {dialogeContent.actionTitle}
            </button>
          )}
          <button className="text-black bg-white popup-button-cancel" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtifactStateDialog;
